//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'
import TimeTo from '@/class/TimeTo'

export default {
  name: 'TimeCard',
  created: function () {
    moment.locale(this.$store.state.local)
  },
  data () {
    return {
      momentjs: moment,
      TimeTo: new TimeTo()
    }
  },
  computed: {
    Local: function () {
      return this.$store.state.local
    },
    TimeOptimyze: function () {
      const comparator = this.$store.state.operation.Comparator()
      return Math.floor(comparator[comparator.length - 1].Time)
    }
  }
}
